'use client';

import { CSSProperties, HTMLAttributes } from 'react';
import styles from './style.module.scss';

type FlexDirection = 'row' | 'column' | 'row-reverse' | 'column-reverse';
type AlignItems = 'flex-start' | 'flex-end' | 'center' | 'baseline' | 'stretch';

interface FlexContainerProps extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  gap?: number;
  alignItems?: AlignItems;
  justifyContent?: CSSProperties['justifyContent'];
  flexDirection?: FlexDirection;
  width?: string;
  height?: string;
  style?: CSSProperties;
  className?: string;
  wrap?: boolean;
  inline?: boolean;
}

export function FlexContainer({
  children,
  gap = 0,
  alignItems = 'center',
  justifyContent = 'center',
  flexDirection = 'row',
  height,
  width,
  style,
  className,
  ...props
}: FlexContainerProps) {
  const dynamicStyles: CSSProperties = {
    ...style,
    gap: `${gap}px`,
    alignItems,
    justifyContent,
    flexDirection,
    height,
    width,
  };

  return (
    <div
      className={`${styles.container}${className ? ` ${className}` : ''}`}
      style={dynamicStyles}
      {...props}
    >
      {children}
    </div>
  );
}

FlexContainer.displayName = 'FlexContainer';
